import {
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react';
import uniqueId from 'lodash/uniqueId';
import React from 'react';

import {
  ExportButton,
  ExportIcon,
  ImageIcon,
  PdfIcon,
  PngIcon,
  SpreadsheetIcon,
} from '../../styles';

interface ExportPopoverProps {
  exportXlsx?: () => void;
  onExportPdf?: () => void;
  exportImage?: (exportType: string) => void;
  exportTypes?: string[];
  buttonClasses?: string;
}

const ExportPopover: React.FC<ExportPopoverProps> = ({
  exportXlsx,
  onExportPdf,
  exportImage,
  exportTypes,
  buttonClasses,
}: ExportPopoverProps) => {
  return (
    <Popover placement="bottom-end" key={uniqueId()}>
      <PopoverTrigger>
        <ExportButton className={buttonClasses}>
          <ExportIcon />
        </ExportButton>
      </PopoverTrigger>
      <Portal>
        <PopoverContent style={{ maxWidth: '140px' }}>
          <PopoverArrow />
          <PopoverBody style={{ margin: 0, padding: 0 }}>
            {exportXlsx &&
              (exportTypes?.length === 0 || exportTypes?.includes('xlsx')) && (
                <Button
                  display="flex"
                  justifyContent="flex-start"
                  gap="4px"
                  width="100%"
                  variant="ghost"
                  onClick={() => exportXlsx()}
                >
                  <SpreadsheetIcon size={18} />
                  <Text>Exportar em .xlsx</Text>
                </Button>
              )}
            {onExportPdf &&
              (exportTypes?.length === 0 ||
                exportTypes?.includes('pdf_dashboard')) && (
                <Button
                  display="flex"
                  justifyContent="flex-start"
                  gap="4px"
                  width="100%"
                  variant="ghost"
                  onClick={() => onExportPdf()}
                >
                  <PdfIcon size={18} />
                  <Text>Gerar tabela em .pdf</Text>
                </Button>
              )}
            {exportImage && (
              <>
                {exportTypes?.includes('jpeg') && (
                  <Button
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      gap: '4px',
                    }}
                    width="100%"
                    variant="ghost"
                    onClick={() => exportImage('jpeg')}
                  >
                    <ImageIcon size={18} />
                    <Text>Exportar em .jpeg</Text>
                  </Button>
                )}
                {exportTypes?.includes('png') && (
                  <Button
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      gap: '4px',
                    }}
                    width="100%"
                    variant="ghost"
                    onClick={() => exportImage('png')}
                  >
                    <PngIcon size={18} />
                    <Text>Exportar em .png</Text>
                  </Button>
                )}
                {exportTypes?.includes('pdf') && (
                  <Button
                    display="flex"
                    justifyContent="flex-start"
                    gap="4px"
                    width="100%"
                    variant="ghost"
                    onClick={() => exportImage('pdf')}
                  >
                    <PdfIcon size={18} />
                    <Text>Exportar em .pdf</Text>
                  </Button>
                )}
              </>
            )}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default ExportPopover;
